import { createSelector } from 'reselect';

const getErrorMessages = (state) => state.messages.app.errorMessages;

const selectAppErrorMessage = (errorMessage) =>
  createSelector(getErrorMessages, (errorMessages) =>
    errorMessages.find((item) => item.type === errorMessage),
  );

const getMessages = (state) => state.messages.app.messages;

const hasMessage = (type) =>
  createSelector(getMessages, (messages) => messages.some((item) => item.type === type));

export const errorMessagesSelectors = {
  getErrorMessages,
  selectAppErrorMessage,
};

export const messagesSelectors = {
  getMessages,
  hasMessage,
};
